import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'CartItem', uniqId: 'IMeq8W' })(
  ({ breakpoints, spacing, typography: { pxToRem }, brandColors }) => ({
    container: {
      display: 'flex',
      paddingTop: spacing(2), // flex gap doesn't play nice with list animation
      gap: spacing(0),
      [breakpoints.up('sm')]: { gap: spacing(1) },
    },
    thumbnail: {
      objectFit: 'cover',
      borderRadius: pxToRem(8),
      border: `${pxToRem(1)} solid ${brandColors.tintsOffWhite40}`,
      width: pxToRem(60),
      height: pxToRem(60),
      [breakpoints.up('sm')]: { width: pxToRem(100), height: pxToRem(100) },
    },
    midSection: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(1),
    },
    nameAndDescription: {
      display: 'flex',
      flexDirection: 'column',
      gap: pxToRem(8),
    },
    description: {
      color: `${brandColors.tintsNeutral20} !important`,
    },
    qtyAndRemove: {
      display: 'flex',
      gap: spacing(0),
    },
    removeBtn: {
      cursor: 'pointer',
    },
    price: {
      color: brandColors.black,
      textAlign: 'right',
      minWidth: pxToRem(100),
    },
  })
);

export default useStyles;
